import { Component, Input } from '@angular/core';
import { QRCodeElementType } from 'angularx-qrcode';

@Component({
  selector: 'monorepo-qr-code-generator',
  templateUrl: './qr-code-generator.component.html',
  styleUrls: ['./qr-code-generator.component.scss'],
})
export class QrCodeGeneratorComponent {
  @Input() elementType: QRCodeElementType = 'img';
  @Input() errorCorrectionLevel = 'H';
  @Input() value = '';
  @Input() margin = 4;
  @Input() width = 260;
  @Input() showDownloadBtn = false;
  @Input() fileNameToDownload = 'qr-code';

  downloadQRCode() {
    const base64Img = (document.getElementsByClassName('QRCode')[0].children[0] as HTMLImageElement)?.src;
    fetch(base64Img)
      .then((res) => res.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.fileNameToDownload;
        link.click();
      });
  }
}
